/**************************************************
 * Nombre:       Formulario_Retiro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountBalance,
    AccountBalanceWallet,
    AccountCircleOutlined,
    BadgeOutlined,
    MailOutline,
    Numbers
} from "@mui/icons-material";
import {useContext, useEffect, useState} from "react";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {usuarioContext} from "../../App";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import Tarjeta_Ahorro from "../Tarjetas_Especiales/Tarjeta_Ahorro";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {obtenerTotalAhorrado} from "../../CodNegocio/Bolsillo/obtenerTotalAhorrado";
import {obtenerMesesTranscurridos} from "../../CodNegocio/Bolsillo/obtenerMesesTranscurridos";
import {obtenerDiasFaltantes} from "../../CodNegocio/Bolsillo/obtenerDiasFaltantes";
import {BANCOSACEPTADOS, TIPOCUENTA} from "../../Constantes";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";


const Formulario_Retiro = ({...props}) => {
    const cData = useContext(usuarioContext)
    const [bolsillos, setBolsillos] = useState([]);
    const [escogido, setEscogido] = useState('')
    const [hayComisiones, setHayComisiones] = useState(false)
    const [diasFaltantes, setDiasFaltantes] = useState(0)

    const obtenerBolsillo = async (e) => {

        let index = bolsillos.findIndex(b => b.nombre === e);
        let bol = bolsillos[index]
        setEscogido(bol);

        if (bol) {
            let mesTras = obtenerMesesTranscurridos({bolsillo: bol})
            let dias = obtenerDiasFaltantes({bolsillo: bol})
            let valor = await obtenerTotalAhorrado({idBolsillo: bol.id})
            props.props.setValue('valor', valor)
            props.props.setValue('cc', bol.cc)
            props.props.setValue('correo', bol.correo)
            props.props.setValue('nombresUsuario', bol.nombresUsuario)
            props.props.setValue('mesesTranscurridos', mesTras)
            props.props.setValue('idBolsillo', bol.id)
            props.props.setValue('nombreBolsillo', bol.nombre)


            setDiasFaltantes(dias)

            if (bol.numMeses >= mesTras) {
                setHayComisiones(true)
            } else {
                setHayComisiones(false)
            }

        }


    }


    useEffect(() => {

        if (cData.usuario.id) {
            let w = [where('idUsuario', '==', cData.usuario.id)];
            obtenerColWheres({col: 'bolsillos', wheres: w}).then((dox) => {
                if (dox.res) {
                    setBolsillos(dox.data);
                }
            })
        }


    }, [cData]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoSelectFuncion Icono={AccountCircleOutlined} nombre={'Nombres del Ahorro'}
                                          dato={'nombre'} {...props} setDato={obtenerBolsillo}
                                          requerido={'Campo Requerido'} opciones={bolsillos.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    {escogido &&
                        <Tarjeta_Ahorro item={escogido}/>
                    }
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor a Retirar'} dato={'valor'} {...props}
                                   requerido={'Campo Requerido'}
                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Documento'} dato={'cc'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Nombre de usuario'}
                                  dato={'nombresUsuario'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo de usuario'}
                                  dato={'correo'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Cuenta a la que se transferira</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={AccountBalance} nombre={'Nombre del Banco'}
                                   dato={'banco'} {...props} opciones={BANCOSACEPTADOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={AccountBalanceWallet} nombre={'Tipo de cuenta'}
                                   dato={'tipoCuenta'} {...props} opciones={TIPOCUENTA.map((it) => it.nombre)}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Numbers} nombre={'Numero de Cuenta'}
                                  dato={'numCuenta'} {...props}
                    />
                </Grid>


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        p: 1
                    }}
                >
                    {hayComisiones &&

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: 14}}>{'**Puedes retirar cuando quieras, te ' +
                                'recomendamos que para que recibas la totalidad de tu ahorro y rendimientos lo hagas ' +
                                `terminado el tiempo del ahorro, esto será en (${diasFaltantes}) dias`}</Typography>
                        </Grid>
                    }

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Retiro